// Loading Animation
import React from "react";

const LoadingAni = () => {
    return (
    <div className="loader" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', backgroundColor: 'black' }}>
      <img src="img/Logo Red.svg" alt="Red Logo" height={200}/>
      {}
    </div>
  );
};

export default LoadingAni;